<template>
    <v-app id="app">
        <!-- App bar -->
        <v-app-bar app clipped-right color="bal-gray" light flat>
            <v-app-bar-nav-icon large @click.stop="toggleDrawer" />
            <v-toolbar-title>{{ `${$route.meta.title}` | t }}</v-toolbar-title>
            <button class="custom-filter-btn ml-6" v-if="firstLoadingDone" @click="toggleFilterVisible">
                <i class="material-icons">filter_list</i>
                <span>{{ "Filter" | t }}</span>
            </button>
            <v-spacer></v-spacer>
            <v-btn
                @click="handleExportClick"
                class="px-2 ml-2 mx-2"
                color="bal-red"
                dark
                style="min-width: 0"
                v-if="!exportDisabled"
                :loading="exportLoading"
            >
                {{ "Export" | t }}
                <v-icon class="pl-2">{{ "fas fa-file-export" }}</v-icon>
            </v-btn>
        </v-app-bar>

        <!-- Drawer left -->
        <main-drawer :drawer-open="mainDrawerOpen" @close="toggleDrawer" />

        <!-- Main content -->
        <v-main>
            <router-view />
        </v-main>

        <v-snackbar color="error" bottom :value="requestError">
            <div style="display: flex; flex-direction: row">
                <v-icon color="#FFF">error</v-icon>
                <div class="title pa-2">{{ errorMsg }}</div>
            </div>
        </v-snackbar>

        <!-- Footer -->
        <page-footer />
    </v-app>
</template>
<script>
import MainDrawer from "../components/main-drawer.vue";
import PageFooter from "../components/page-footer.vue";
import AnalysisView from "../pages/analysis/analysis-view.vue";
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import Store from "../store";

export default {
    name: "analysis-layout",
    components: {
        AnalysisView,
        PageFooter,
        MainDrawer,
    },
    data() {
        return {
            mainDrawerOpen: null,
            error: false,
        };
    },
    mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        const drawerState = localStorage.getItem("mainDrawerOpen");
        if (drawerState) {
            this.mainDrawerOpen = JSON.parse(drawerState);
        } else {
            this.mainDrawerOpen = true;
        }
    },
    beforeDestroy() {
      this.resetView()
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    computed: {
        ...mapState("AnalysisStore", ["requestError", "errorMsg", "dataLoading", "exportLoading"]),
        ...mapGetters("AnalysisStore", ["filteredSales"]),
        exportDisabled() {
            return !this.filteredSales() || this.filteredSales().length === 0 || this.dataLoading;
        },
        ...mapState("AnalysisStore", ["requestError", "errorMsg", "firstLoadingDone", "filters", "datesChanged"]),
    },
    watch: {
        requestError: (value) => {
            if (value)
                setTimeout(() => {
                    Store.commit("AnalysisStore/setRequestError", false);
                    Store.commit("AnalysisStore/setErrorMessage", "");
                }, 3500);
        },
    },
    methods: {
        ...mapMutations("AnalysisStore", ["setErrorMessage", "setRequestError", "toggleFilterVisible", "resetView"]),
        ...mapActions("AnalysisStore", ["fetchData", "exportFilteredDataExcel"]),
        handleKeyboardListener(e) {
            if (e.keyCode === 27 || e.key === "Escape") this.toggleFilterVisible();
            if (document.activeElement.tagName !== "INPUT" && (e.keyCode === 13 || e.key === "Enter")) {
                if (this.filters.periodRange && this.datesChanged) {
                    this.fetchData();
                }
            }
        },
        toggleDrawer() {
            this.mainDrawerOpen = !this.mainDrawerOpen;
            localStorage.setItem("mainDrawerOpen", this.mainDrawerOpen);
        },
        handleExportClick() {
            const filteredData = this.filteredSales();
            if (!filteredData || filteredData.length === 0) return;

            const saleIds = [];
            const importIds = [];

            filteredData.forEach((sale) => {
                if (sale.item_type === "invoice") {
                    saleIds.push(sale.id);
                } else if (sale.item_type === "import") {
                    importIds.push(sale.id);
                }
            });

            this.exportFilteredDataExcel({ saleIds, importIds });
        },
    },
};
</script>

<style scoped>
.custom-filter-btn {
    height: 36px;
    border-radius: 8px;
    padding: 7px 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 6px;
    background-color: white;
    cursor: pointer;
    font-family: inherit;
    color: black;
    text-transform: none;
    box-shadow: none;
}

.custom-filter-btn i {
    color: gray;
    font-size: 20px;
}

.custom-filter-btn:hover {
    background-color: #f5f5f5;
}
</style>
